import { lazy } from "react";
import { MODULE_IDS } from "../../constants/enums";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { app_navbar_routes } from "../../constants/app-navbar-routes";

//************************ Purchase Order Imports ***************************/
const ServiceOrderTable = Loadable(
  lazy(() =>
    import("./ServiceOrderTable").then(({ ServiceOrderTable }) => ({
      default: ServiceOrderTable,
    })),
  ),
);

const SingleServiceOrderForm = Loadable(
  lazy(() =>
    import("./SingleServiceOrderForm").then(({ SingleServiceOrderForm }) => ({
      default: SingleServiceOrderForm,
    })),
  ),
);

//************************ Service Order Routes ***************************/
export const serviceOrderRoutes = [
  {
    path: app_navbar_routes.app.service.service_order,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.SERVICE_ORDER]}>
        <ServiceOrderTable module="GENERAL" />
      </AuthorizedRoute>
    ),
  },
  {
    path: app_navbar_routes.app.approvals.service_order,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.SERVICE_ORDER]}>
        <ServiceOrderTable module="APPROVAL" />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${app_navbar_routes.app.service.service_order}/manage`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.SERVICE_ORDER]}>
        <SingleServiceOrderForm />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${app_navbar_routes.app.service.service_order}/manage/:uuid`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.SERVICE_ORDER]}>
        <SingleServiceOrderForm />
      </AuthorizedRoute>
    ),
  },
];
